<script>
    import { onMount } from "svelte";
    import SvelteTable from "svelte-table";
    import client from "../client";
    import ClockAnimation from "../components/images/ClockAnimation.svelte";
    // export let params;

    let alert_message;
    let loading = true;
    let results = [];
    let challenges = [];
    let challenge_select;
    let challenge_data;
    

    onMount(async () => {
        try {
            let challengeT = await client.service('challenge').find({
                query: {
                    $sort: { name: 1 },
                    $limit: 100
                }
            });
            challenges = challengeT.data;
            loading = false;
        } catch(err) {
            console.error(err);
            alert_message = "Error Retrieving Challenges";
            loading = false;
        }
    });

    async function selectChallenge() {
        try {
            loading = true;
            let challengeT = await client.service('challenge').find({
                query: {
                    id : challenge_select.id,
                }
            });
            challenge_data = challengeT.data[0];
            results = [];
            results = await client.service('results').find({
            query: {
                  option : "challengeResults",
                  from : challenge_data.start,
                  to : challenge_data.end,
                  athletes: challenge_data.athletes
              }
            });
            if (results) {
              for (let index = 0; index < results.length; index++) {
                results[index].position = index + 1;
              }
              loading = false;  
            } else {
              alert_message = "No Results Found";
            }
            loading = false;
        } catch(err) {
            console.error(err);
            alert_message = alert_message = "Error Retrieving Challenge Athletes";
            loading = false;
        }
    }

    const columns = [
        {
          key: "",
          title: "Position",
          value: v => v.position,
          sortable: false,
          headerClass: "text-center",
          class: "text-center",
        },
        {
            key: "Total",
            title: "Total Km's",
            value: v => v.Total + " Km",
            sortable: false,
            headerClass: "text-center",
            class: "text-center",
        },        
        {
            key: "Races",
            title: "Total Races",
            value: v => v.Races,
            sortable: false,
            headerClass: "text-center",
            class: "text-center",
        },
        {
            key: "name",
            title: "First Name",
            value: v => v.name,
            sortable: false,
            headerClass: "text-left",
            class: "text-left"
        },
        {
            key: "surname",
            title: "Surname",
            value: v => v.surname,
            sortable: false,
            headerClass: "text-left",
            class: "text-left"
        },
    ];
</script>

<div class="card" style="margin-top:10px;">
    <div class="card-content">
      <p class="title">
        Challenges
      </p>
      <p class="subtitle">
        Different Challenges unique to Revolution Trails.
      </p>
      
        {#if alert_message}
        <div class="notification is-light is-danger">{@html alert_message}</div>
        {/if}
        <div style="margin-bottom:5px;">
          <select class="input is-primary" bind:value={challenge_select} on:change="{() => selectChallenge()}" required>
            <option value="" disabled selected>Select Challenge</option>
            {#each challenges as v}
               <option value={v}>{v.name}</option>
            {/each}
          </select>
          </div>
        {#if loading}
          <div style="width:200px;margin-left:auto;margin-right:auto;">
          <ClockAnimation />
        </div>
        {:else}
        {#if results.length > 0}
        <div class="table-container" style="margin-bottom:5px;">
          <SvelteTable 
            columns={columns} 
            rows={results} 
            classNameTable={['table is-hoverable is-fullwidth']} 
          >
            <!-- <tr slot="row" let:row let:n>
              <td style="cursor:pointer" onclick="location.href='/{row.id}/A'">
                {row.name} - {convertDateTimeMonthAndDay(row.start_date, 2)}
              </td>
            </tr> -->
          </SvelteTable>
        </div>  
        {/if}
        {#if results.length == 0 && challenge_select}
        <div class="notification is-light is-warning">No Results for Current Challenge.</div>
        {/if}
      {/if}
      
    </div>
  </div>

  <style>
    :global(.text-center) {
      text-align: center;
    }
    :global(.text-left) {
      text-align: left;
    }
  </style>